const CompanyInfo = ({ company_data }) => {
    const fields = [
      ["Name", "name"],
      ["Address", "address"],
      ["Fiscal Number", "fiscal_number"],
      ["Postal Code", "postal_code"],
      //["Phone Number", "phone"],
      //["Email Address", "email"],
      //["Website", "website"],
      //["Year Established", "year"],
      //["Employees", "employees"],
      ["Latitude", "latitude"],
      ["Longitude", "longitude"],
    ];
  
    return (
      <div className="w-5/12 mr-2">
        <h3 className="text-xl font-bold mt-4 mb-2 text-blue-900">Company Data</h3>
        {fields.map(([label, key]) => (
          <p className="ml-2" key={key}>
            <strong>{label}:</strong> {company_data[key] || ""}
          </p>
        ))}
      </div>
    );
  };
  
  export default CompanyInfo;
  